module.exports = __webpack_public_path__ + "static/media/mic_waveform_dark.1b942ccb.svg";